import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const SmsCredentialList = Loadable(
  lazy(() => import("features/notification/credentialsSms/components/List"))
);
const SmsCredentialPage = Loadable(
  lazy(() => import("features/notification/credentialsSms/components/Page"))
);

const routes = {
  path: "sms",
  children: [
    { path: "", element: <SmsCredentialList /> },
    { path: "add", element: <SmsCredentialPage /> },
    { path: "edit/:credentialID?", element: <SmsCredentialPage /> },
  ],
};

export default routes;
